import React from 'react';

export default function MenuCompletionBanner({
  isDarkMode = false,
  className = '',
  title = 'Şefim, afiyet olsun',
  subtitle = 'Bu öğünü tamamladık.',
  detail = 'Diğer öğünler bildirim yapılmasını istediğin saatte hazırlanacak.'
}) {
  return (
    <div
      className={[
        'w-full rounded-2xl border px-4 py-4 text-center',
        isDarkMode
          ? 'border-slate-700 bg-slate-800/70 text-slate-100'
          : 'border-slate-200 bg-slate-100 text-slate-700',
        className
      ].join(' ')}
    >
      <p className="text-base md:text-lg font-black">{title}</p>
      <p className="text-sm md:text-base font-bold mt-1">{subtitle}</p>
      <p className="text-sm md:text-base font-bold">{detail}</p>
    </div>
  );
}
